import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
} from '@mui/material';
import { Sparkles, Zap } from 'lucide-mui';
import { useLimits } from '../../../plan/hooks/limits';

const ChatLimitReached: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const guardLimits = useLimits();

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpanded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpgradeClick = () => {
    guardLimits('askAI', () => {});
  };

  return (
    <Collapse in={expanded}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        textAlign="center"
        py={2}
      >
        <Sparkles sx={{ fontSize: 45, color: 'info.main' }} />
        <Typography variant="h5" color="textPrimary" mt={2}>
          AI Chat Limit Reached
        </Typography>
        <Typography variant="body1" color="textSecondary" mt={1}>
          You&apos;ve used all available AI interactions for your current plan.
          Upgrade to continue.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClickOpen}
            sx={{ mr: 2 }}
          >
            Learn More
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Zap />}
            onClick={handleUpgradeClick}
          >
            Upgrade
          </Button>
        </Box>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Why Can&apos;t I Use AI Chat?</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              AI Chat allows you to interact with an AI to get insights about
              your content. It&apos;s a powerful tool to help you understand and
              analyze your audio or video. Ask questions and get timestamped
              responses, allowing you to jump directly to relevant parts of your
              recording.
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              You&apos;ve reached the limit of AI interactions your current plan
              allows. Upgrade to continue using AI Chat and unlock more
              features.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Zap />}
              onClick={handleUpgradeClick}
            >
              Upgrade
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Collapse>
  );
};

export default ChatLimitReached;
